module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_cuad_21.e3a16d42.png";